import React from "react";

const CheckIcon = ({ className }) => {
  return (
    <svg
      viewBox="0 0 39 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M15.0509 29.4221C14.6882 29.793 14.1933 30 13.6792 30C13.1651 30 12.6702 29.793 12.3075 29.4221L1.35266 18.2822C0.215782 17.1263 0.215782 15.2519 1.35266 14.0982L2.72436 12.7032C3.86159 11.5473 5.70297 11.5473 6.83985 12.7032L13.6792 19.6573L32.1602 0.866916C33.2974 -0.288972 35.1405 -0.288972 36.2756 0.866916L37.6473 2.26193C38.7842 3.41782 38.7842 5.2918 37.6473 6.44588L15.0509 29.4221Z" fill="currentColor" />
    </svg>
  );
};

export default CheckIcon; 
